import script from "./children.vue?vue&type=script&setup=true&lang=ts"
export * from "./children.vue?vue&type=script&setup=true&lang=ts"

import "./children.vue?vue&type=style&index=0&id=33759b85&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33759b85"]])

export default __exports__